import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import { Button } from "react-bootstrap";
import { QueueStartDate } from "../common";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { DateRangePicker } from "react-dates";
import { toast } from "react-toastify";
import {
  searchPartialMatchesPaged,
  openMerge,
  assignAndOpen,
  unAssign,
  cancelMerge,
  markAsNew,
  doAutoMerge,
  sendToManagement,
  getPartialMatches
} from "./redux-objects/actions";
import { loadImage } from "../Keywords/redux-objects/actions";
import { UserInfo, hasPermission } from "../../Login/common/defaults";
import * as urls from "../../shared/urls";
import {
  IMatch,
  IMatchingQueuePagedResult,
  PartialMatchQueueItem
} from "./business-objects/common";
import "./matchingqueue.css";
import { confirm } from "react-bootstrap-confirmation";
import {
  IExportColumnMap,
  IWorkflowItemStep,
  PagedResultsRequest,
  SearchQueuePagedRequest
} from "../../../common/sharedTypes";
import PagedDatatable from "../../PagedDataTable";
import { TableColumn } from "react-data-table-component/dist/DataTable/types";
import LocalStorageUtils from "../common/LocalStorageUtils";
export interface IMatchingQueuePagedActionProps {
  searchPartialMatchesPaged?: (
    url: string,
    request: SearchQueuePagedRequest
  ) => void;
  openMerge?: (workflowItemStep: IWorkflowItemStep) => Promise<void>;
  cancelMerge?: (
    url: string,
    keywordsId: number,
    workflowItemStepId: number
  ) => Promise<void>;
  assignAndOpen?: (
    url: string,
    stepItemId: number,
    keywordsIdToMerge: number,
    assignToId: number
  ) => Promise<void>;
  doAutoMerge?: (
    url: string,
    reportId1: number,
    reporrtId2: number,
    workflowItemStepId: number
  ) => Promise<void>;
  unAssign?: (
    url: string,
    stepItem: IWorkflowItemStep | PartialMatchQueueItem
  ) => Promise<void>;
  markAsNew?: (
    url: string,
    stepItem: IWorkflowItemStep | PartialMatchQueueItem
  ) => Promise<void>;
  sendToManagement?: (url: string, stepItemId: number) => Promise<void>;
  loadImage?: (documentId: string, forceNewWindow: boolean) => Promise<void>;
}

interface IMatchingQueuePagedStateProps {
  results: IMatchingQueuePagedResult[];
  webServiceURL: string;
  isProcessing: boolean;
  history: any;
  currentUser: UserInfo;
  loadingWorkflowSteps: boolean;
  totalWorkflowItemSteps: number;
}

interface IMatchingQueuePagedProps
  extends IMatchingQueuePagedActionProps,
  IMatchingQueuePagedStateProps { }

enum ModalMode {
  None,
  New,
  Editing
}

enum ServiceEndPoints {
  SearchPaperReportDataQueue = "SearchPaperReportDataQueue",
  AssignWorkflowItemStep = "AssignWorkflowItemStep",
  UnAssignWorkflowItemStep = "UnAssignWorkflowItemStep"
}

const initialState = {
  userOnly: false,
  assignedOnly: false,
  // // startDate: moment(
  // //   moment().startOf("year").format("DD/MM/YYYY"),
  // //   "DD/MM/YYYY"
  // // ),
  // // endDate: moment(moment().endOf("year").format("DD/MM/YYYY"), "DD/MM/YYYY"),
  startDate: moment(QueueStartDate),
  endDate: moment(),
  focusedInput: null,
  showModal: false,
  modalStatus: ModalMode.None,
  openingReport: false,
  merging: false,
  pagingCriteria: {
    itemsPerPage: 10,
    pageNumber: 1,
    searchCriteria: null,
    orderByField: "Id",
    orderDescending: false
  }
};
type MatchingQueuePagedState = Readonly<typeof initialState>;

class MatchingQueuePaged extends React.Component<
  IMatchingQueuePagedProps,
  MatchingQueuePagedState
> {
  public constructor(props: IMatchingQueuePagedProps) {
    super(props);
    this.state = initialState;
  }

  // TODO: Refactor to configuration file
  private workflowController: string = "Workflow";
  private startDateVariable: string = "MatchingStartDate";
  private endDateVariable: string = "MatchingEndDate";

  componentDidMount() {
    this.populateMatchingQueue();
  }

  closeModal = (e?) => {
    this.toggleScrollLock();
    this.setState({
      modalStatus: ModalMode.None,
      showModal: false
    });
  };

  getButton = (
    matchRowData?: IMatch,
    resultItem?: IMatchingQueuePagedResult
  ) => {
    if (resultItem.workflowItemStep.mergeStatusId == -3) {
      if (matchRowData.report.keywords.mergeStatusId != -3) {
        if (
          matchRowData.report.keywords.id ===
          resultItem.workflowItemStep.mergedToReportId
        )
          return (
            <span className="special">
              This is the new item being merged to!
            </span>
          );
        return "No Actions available while merge in progress";
      }
    }

    const viewImageButton = (
      <Button 
        variant="outline-primary"
        size="sm"
        className="mt-10"
        style={{ fontSize: "12px" }}
        onClick={(e) =>
          this.doLoadImage(matchRowData.report.keywords.documentId)
        }
      >
        View Report
      </Button>
    );

    const mergeButton = (
      <Button
        variant="outline-primary"
        size="sm"
        style={{ fontSize: "12px" }}
        className="mt-10"
        onClick={(e) => this.handleAutoMerge(matchRowData, resultItem)}
        disabled={this.state.merging}
      >
        {matchRowData.report.mergeStatusId == -3 ? "Continue Merge" : "Merge"}
      </Button>
    );

    const cancelButton =
      matchRowData.report.mergeStatusId == -3 ? (
        <Button
          variant="outline-danger"
          size="sm"
          style={{ fontSize: "12px" }}
          onClick={(e) =>
            this.handleCancelMerge(
              matchRowData.report.mergedToReportId,
              resultItem.workflowItemStep.id
            )
          }
        >
          Cancel Merge
        </Button>
      ) : (
        ""
      );

    const d = (
      <React.Fragment>
        {viewImageButton}
        {"  "}
        {mergeButton}
        {"  "}
        {cancelButton}
      </React.Fragment>
    );
    return d;
  };

  handleViewReportPDF(rowData: any) {
    this.props.loadImage(
      rowData.workflowItemStep.report.keywords.documentId,
      true
    );
  }

  sendToManagementQueue = (rowData: any) => {
    try {
      this.props
        .sendToManagement(
          urls.SEND_TO_MANAGEMENT_QUEUE,
          rowData.workflowItemStep.id
        )
        .then(() => {
          toast.success("Sent to Management");
        });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };

  doLoadImage(documentId: string) {
    this.props.loadImage(documentId, true);
  }

  expandedRowComponent = (rowItem) => {
    const rowData: IMatchingQueuePagedResult = rowItem.data;
    return (
      <table className="match-results-table">
        <thead>
          <tr>
            <th className='matching-result-actions'>ACTIONS</th>
            <th className='matching-result-general'>Date of Crash</th>
            <th className='matching-result-general'>Report Type</th>
            <th className='matching-result-general'>Crash Key</th>
            <th className='matching-result-general'>County</th>
            <th className='matching-result-general'>Involved Parties</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {rowData.matches.map((m) => {
            var btn = this.getButton(m, rowData);

            var ipMatches = m.report.keywords.involvedParties.filter((x) =>
              rowData.workflowItemStep.involvedPartiesFull.some(
                (y) =>
                  ((y.firstName ?? "").toLocaleLowerCase() == (x.firstName ?? "").toLocaleLowerCase() &&
                    (y.lastName ?? "").toLocaleLowerCase() == (x.lastName ?? "").toLocaleLowerCase())
                  ||
                  (y.businessName ?? "").toLocaleLowerCase() == (x.businessName ?? "").toLocaleLowerCase()
              )
            );
            return (
              <tr
                key={m.report.id}
                className={m.report.mergeStatusId === -3 ? "merging" : ""}
              >
                <td>{btn}</td>
                <td
                  className={
                    moment(m.report.keywords.dateOfCrash).isSame(
                      rowData.workflowItemStep.dateOfCrash,
                      "day"
                    )
                      ? "match"
                      : "nomatch"
                  }
                >
                  {moment(m.report.keywords.dateOfCrash).format("L")}
                </td>
                <td>{m.report?.keywords?.reportType?.name}</td>
                <td>{m.report?.keywords?.originalCrashKey}</td>
                <td
                  className={
                    m.report.keywords.county.name ==
                      rowData.workflowItemStep.report.keywords.county.name
                      ? "match"
                      : "nomatch"
                  }
                >
                  {m.report.keywords.county.description}
                </td>
                <td
                  colSpan={3}
                  className={ipMatches.length > 0 ? "match" : "nomatch"}
                >
                  {ipMatches.length <= 0 ? (
                    <ul className="involvedPartyList">
                      <li>No Matches</li>
                    </ul>
                  ) : (
                    <ul className="involvedPartyList">
                      {ipMatches.map((x) => {
                        return (
                          <li key={x.id}>
                            {x?.firstName} {x?.lastName} {x?.businessName}
                          </li>
                        );
                      })}
                    </ul>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  toggleScrollLock = () => {
    document.querySelector("html").classList.toggle("scroll-lock");
  };

  refreshPaperReports() {
    this.populateMatchingQueue();
  }
  populateMatchingQueue() {
    const persistentStartDate = LocalStorageUtils.getLocalStorageDate(
      this.startDateVariable
    );
    const persistentEndDate = LocalStorageUtils.getLocalStorageDate(
      this.endDateVariable
    );
    const request: SearchQueuePagedRequest = {
      ...this.state.pagingCriteria,
      userOnly: false,
      assignedOnly: false,
      startDate: persistentStartDate
        ? persistentStartDate.toDate().toUTCString()
        : this.state.startDate.toDate().toUTCString(),
      endDate: persistentEndDate
        ? persistentEndDate.toDate().toUTCString()
        : this.state.endDate.toDate().toUTCString(),
      includeNewDriverReports: false,
      unassignedOnly: false,
    };

    this.props.searchPartialMatchesPaged(
      urls.MATCHING_QUEUE_SEARCH_PAGED,
      request
    );
  }

  getExportData = async () => {
    const persistentStartDate = LocalStorageUtils.getLocalStorageDate(
      this.startDateVariable
    );
    const persistentEndDate = LocalStorageUtils.getLocalStorageDate(
      this.endDateVariable
    );
    const request: SearchQueuePagedRequest = {
      ...this.state.pagingCriteria,
      itemsPerPage: this.props.totalWorkflowItemSteps,
      pageNumber: 1,
      userOnly: false,
      assignedOnly: false,
      startDate: persistentStartDate
        ? persistentStartDate.toDate().toUTCString()
        : this.state.startDate.toDate().toUTCString(),
      endDate: persistentEndDate
        ? persistentEndDate.toDate().toUTCString()
        : this.state.endDate.toDate().toUTCString(),
      includeNewDriverReports: false,
      unassignedOnly: false,
    };

    const response = await getPartialMatches(
      urls.MATCHING_QUEUE_SEARCH_PAGED,
      request
    );

    if (response.ok) {
      return response.data.results.map((r) => {
        return {
          id: r?.workflowItemStep?.id,
          dateOfCrash: r?.workflowItemStep?.dateOfCrash,
          reportType: r?.workflowItemStep?.reportType,
          crashKey: r?.workflowItemStep?.originalCrashKey,
          county: r?.workflowItemStep?.county,
          involvedParties: r?.workflowItemStep?.involvedParties.join(" "),
          mergeStatus: r?.workflowItemStep?.mergeStatus,
          workflowStatus: r?.workflowItemStep?.workflowStatus
        };
      });
    }
    return [];
  };

  handleDatesChanged(startDate, endDate) {
    if (startDate && endDate) {
      LocalStorageUtils.setLocalStorageItem(this.startDateVariable, startDate);
      LocalStorageUtils.setLocalStorageItem(this.endDateVariable, endDate);
      this.setState({ startDate, endDate }, () => {
        this.populateMatchingQueue();
      });
    }
  }

  handleAutoMerge = async (
    matchRowData?: IMatch,
    resultItem?: IMatchingQueuePagedResult
  ) => {
    const result = await confirm(
      "Are you sure you want to merge these reports?"
    );
    if (result == true) {
      console.log("Merge");
      this.setState({ merging: true });
      this.props
        .doAutoMerge(
          urls.DO_AUTO_MERGE,
          matchRowData.report.id,
          resultItem.workflowItemStep.reportId,
          resultItem.workflowItemStep.id
        )
        .then(() => {
          this.setState({ merging: false });
          toast.success(
            `Merged ${matchRowData.report.keywords.crashKey} and ${resultItem.workflowItemStep.crashKey}`
          );
          this.populateMatchingQueue();
        })
        .catch((reason) => {
          console.log("Merge failed:", reason);
          toast.error("Merge Failed!");
          this.setState({ merging: false });
        });
    }
  };

  handleCancelMerge(keywordsId: number, workflowItemStepId: number) {
    this.props.cancelMerge(urls.CANCEL_MERGE, keywordsId, workflowItemStepId);
  }

  handleUnAssign(rowData: IMatchingQueuePagedResult) {
    this.props
      .unAssign(urls.UNASSIGN_MERGE, rowData.workflowItemStep)
      .then(() => {
        toast.success("Unassigned");
      });
  }

  handleMarkAsNew(rowData: IMatchingQueuePagedResult) {
    this.props
      .markAsNew(urls.MARK_AS_NEW, rowData.workflowItemStep)
      .then(() => {
        toast.success("Marked as new report");
      });
  }

  handlePagingCriteriaChange = (pagingCriteria: PagedResultsRequest) => {
    this.setState({ pagingCriteria: pagingCriteria as any }, () => {
      this.populateMatchingQueue();
    });
  };

  handleClearDateSelection = (e?: React.MouseEvent<HTMLButtonElement>): void => {
    e?.preventDefault();
    LocalStorageUtils.removeLocalStorageItem(this.startDateVariable);
    LocalStorageUtils.removeLocalStorageItem(this.endDateVariable);
    this.setState(
      {
        startDate: moment(
          moment().startOf("year").format("DD/MM/YYYY"),
          "DD/MM/YYYY"
        ),
        endDate: moment(
          moment().endOf("year").format("DD/MM/YYYY"),
          "DD/MM/YYYY"
        )
      },
      () => {
        this.populateMatchingQueue();
      }
    );
  };
  columns: TableColumn<IMatchingQueuePagedResult>[] = [
    {
      name: "AVAILABLE ACTIONS",
      selector: (row) => row?.workflowItemStep.id,
      sortField: "Id",
      sortable: true,
      wrap: true,
      width: "120px",
      format: (rowData: IMatchingQueuePagedResult) => {
        return (
          <div className="buttonColumn">
            {"   "}
            <Button
              variant="outline-primary"
              size="sm"
              className="mr-10 mt-10"
              onClick={() => this.handleViewReportPDF(rowData)}
            >
              {"   "}
              View Report
            </Button>
            {rowData.workflowItemStep.assignedToUserId == null &&
              rowData.workflowItemStep.mergeStatusId != -3 && (
                <Button
                  variant="outline-primary"
                  size="sm"
                  className="mr-10 mt-10"
                  onClick={(e) => this.handleMarkAsNew(rowData)}
                >
                  {"   "}Mark as New
                </Button>
              )}
            {"   "}
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => this.sendToManagementQueue(rowData)}
              className="mr-10 mt-10"
            >
              Send to Management
            </Button>
            {rowData.workflowItemStep.assignedToUserId != null &&
              hasPermission(this.props.currentUser, "Reviewer") && (
                <Button
                  variant="outline-danger"
                  size="sm"
                  className="mr-10 mt-10"
                  onClick={(e) => this.handleUnAssign(rowData)}
                >
                  {"   "}
                  Unassign
                </Button>
              )}
          </div>
        );
      }
    },
    {
      name: "CRASH DATE",
      sortable: true,
      sortField: "DateOfCrash",
      wrap: true,
      selector: (row) =>
        row?.workflowItemStep.dateOfCrash
          ? moment(row.workflowItemStep.dateOfCrash).format("MM/DD/yyyy")
          : ""
    },
    {
      name: "REPORT TYPE",
      sortField: "ReportType",
      wrap: true,
      selector: (row) => row?.workflowItemStep.reportType || "Unknown",
      sortable: true
    },
    {
      name: "CRASH KEY",
      sortField: "CrashKey",
      wrap: true,
      selector: (row) => row?.workflowItemStep.originalCrashKey || "",
      sortable: true
    },
    {
      name: "COUNTY",
      sortField: "County",
      wrap: true,
      selector: (row) => row?.workflowItemStep.county || "",
      sortable: true
    },
    {
      name: "INVOLVED PARTIES",
      sortField: "InvolvedParties",
      selector: (row) => row?.workflowItemStep.involvedParties.toString() || "",
      wrap: true,
      format: (row) => {
        return (
          <div>
            <ul className="involvedPartyList">
              {row?.workflowItemStep?.involvedParties?.map((ip, index) => {
                return <li key={index}>{ip}</li>;
              })}
            </ul>
          </div>
        );
      },
      sortable: true
    },
    {
      name: 'PRIORITY',
      sortField: 'Priority',
      wrap: true,
      selector: (row) => row?.workflowItemStep.priorityName,
      sortable: true,
    }
  ];

  exportColumnMaps: IExportColumnMap[] = [
    { columnName: "ID", propertyName: "id" },
    {
      columnName: "DATE OF CRASH",
      propertyName: "dateOfCrash",
      convertMethod: (val) => moment(val).format("MM-DD-yyyy")
    },
    {
      columnName: "REPORT TYPE",
      propertyName: "reportType",
      convertMethod: (val) => {
        return val ? val : "Unknown";
      }
    },
    { columnName: "CRASH KEY", propertyName: "crashKey" },
    { columnName: "COUNTY", propertyName: "county" },
    { columnName: "INVOLVED PARTIES", propertyName: "involvedParties" },
    {
      columnName: "PRIORITY",
      propertyName: "priorityName",
    }
  ];

  public render() {
    return (
      <div className="app">
        <div className="row">
          <div className="col-sm-6">
            <h3>Matching</h3>
          </div>
        </div>

        <hr />
        <Form>
          <Form.Row>
            <Form.Group as={Col} controlId="dataEntryQueueStartDate">
              <Form.Label>Crash Date</Form.Label>
              <br />
              <DateRangePicker
                  startDate={
                  LocalStorageUtils.getLocalStorageDate(
                    this.startDateVariable
                  ) || this.state.startDate
                }
                startDateId="dataEntryQueueStartDate"
                endDate={
                  LocalStorageUtils.getLocalStorageDate(this.endDateVariable) ||
                  this.state.endDate
                }
                endDateId="dataEntryQueueEndDate"
                onDatesChange={({ startDate, endDate }) =>
                  this.handleDatesChanged(startDate, endDate)
                }
                focusedInput={this.state.focusedInput}
                onFocusChange={(focusedInput) =>
                  this.setState({ focusedInput })
                }
                isOutsideRange={() => false}
                small={true}
                block={false}
                minimumNights={0}
              />
              {(LocalStorageUtils.getLocalStorageDate(this.startDateVariable) ||
                LocalStorageUtils.getLocalStorageDate(
                  this.endDateVariable
                )) && (
                  <button
                    type="button"
                    className="btn btn-outline-danger btn-sm"
                    style={{ fontSize: "14px", marginLeft: "5px" }}
                    title="Clear Date Filter"
                    onClick={this.handleClearDateSelection}
                  >
                    <i className="fa fa-calendar-xmark" />
                  </button>
                )}
            </Form.Group>
          </Form.Row>
          <Form.Row />
        </Form>
        <PagedDatatable
          columns={this.columns}
          data={this.props.results || []}
          loadingData={this.props.loadingWorkflowSteps}
          totalDataItems={this.props.totalWorkflowItemSteps}
          exportTitle="Partial Match Queue"
          exportFileName="PartialMatchQueue"
          exportColumnMaps={this.exportColumnMaps}
          pagingCriteria={this.state.pagingCriteria}
          updatePagedResults={this.handlePagingCriteriaChange}
          getExportData={this.getExportData}
          expandableRows={true}
          expandableRowsComponent={this.expandedRowComponent}
        ></PagedDatatable>
        {this.state.merging && (
          <div className="divAad">
            <span className="spanMerging">Merging</span>
          </div>
        )}
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    results: state.MatchingQueue.pagedResults,
    webServiceURL: state.Application.backendURL,
    currentUser: state.Application.currentUser,
    loadingWorkflowSteps: state.MatchingQueue.loadingWorkflowSteps,
    totalWorkflowItemSteps: state.MatchingQueue.totalWorkflowItemSteps
  };
}

const mapDispatchToProps = {
  searchPartialMatchesPaged,
  openMerge,
  assignAndOpen,
  unAssign,
  cancelMerge,
  markAsNew,
  loadImage,
  doAutoMerge,
  sendToManagement
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MatchingQueuePaged)
);
